import { Navigate } from "react-router";
import { useGetRoleAssignmentQuery } from "../../../apis/RoleAssignment.api";
import { PrimaryRoleAssignment, RoleAssignment } from "../../../types/models/RoleAssignment";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const RoleAssignmentScoped = () => {
    const {
        data,
    } = useGetRoleAssignmentQuery(PrimaryRoleAssignment.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/role-assignments/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default RoleAssignmentScoped;
